import { Product } from '@df/catalog/product/product';
import { Status } from '@df/core/status';

export namespace NGhostProducts {
    /**
     * Request endoint
     */
    export enum Endpoints {
        load = '/basket/ghostProductsRules'
    }

    export interface ILoadOptions {
        verbosity?: 1 | 2 | 3;
        full?: boolean;
    }

    /**
     * Load GP request
     */
    export interface ILoadRequest {
        quote_id: number;
    }

    /**
     * Load GP response
     *
     * Offers sorted by prioroty, first are the most importnatn
     */
    export type ILoadResponse = {
        ghostProductsRules: IOffer[];
    };

    /**
     * Offer response
     */
    export interface IOffer {
        /**
         * Offered products
         */
        product_ids: number[];
        /**
         * Rule name
         */
        name: string;
        /**
         * Rule subtitle
         */
        subtitle?: string;
        /**
         * Discount percent
         */
        dummy_discount: number;
        rule_type: string;
    }

    /**
     * GP offers processed after load
     *
     * Offers sorted by priorty - important first
     */
    export interface IOfferSet {
        offers: IOfferPrepared[];
    }

    /**
     * FE offer with all data needed
     */
    export interface IOfferPrepared {
        /**
         * Product model
         */
        products: IOfferPreparedProduct[];
        /**
         * Offer name
         */
        name: string;

        /**
         * Offer subtitle
         */
        subtitle: string;
        ruleType: string;
    }

    export interface IOfferPreparedProduct {
        /**
         * Product model
         */
        model: Product;
        /**
         * Submision status
         */
        status: Status;
        /**
         * Price getter
         */
        getPrice: () => number;

        /**
         * Org price getter
         */
        getOrgPrice: () => number;

        /**
         * Add item to basket
         */
        submit: () => void;
    }
}
